import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import brower from './modules/brower'
import subscribe from "./modules/subscribe";
Vue.use(Vuex)

export function createStore() {
  return new Vuex.Store({
    modules: {
      brower,
      user,
      subscribe
    }
  })
}
